import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "quoteleft" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_6 = { width: "30%" }
const _hoisted_7 = { align: "right" }
const _hoisted_8 = ["id", "value"]
const _hoisted_9 = ["for"]
const _hoisted_10 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_11 = { width: "30%" }
const _hoisted_12 = { align: "right" }
const _hoisted_13 = ["id", "onUpdate:modelValue", "value"]
const _hoisted_14 = ["for"]
const _hoisted_15 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_16 = { width: "30%" }
const _hoisted_17 = { align: "right" }
const _hoisted_18 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "policyoptionstable"
}
const _hoisted_19 = { width: "30%" }
const _hoisted_20 = { align: "right" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "additional-table"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { valign: "top" }
const _hoisted_26 = {
  id: "watersewerbackup-content",
  class: "additional-content",
  style: {"display":"none"}
}
const _hoisted_27 = { valign: "top" }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { valign: "top" }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = { valign: "top" }
const _hoisted_32 = { style: {"text-align":"center"} }

import QuoteCart from "@/views/quote/QuoteCart.vue";
import HelpPopup from "@/components/HelpPopup.vue";
import { formatAmountWithoutCents, scrollTop } from "@/utils/Utils";
import Loader from "@/components/MainLoader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import { AssurantData } from "@/api/AssurantData";
import ValidationError from "@/components/ValidationError.vue";
import { inject } from "vue";
import { ref, computed, Ref, ComputedRef } from "@vue/reactivity";
import { useQuoteStore } from "@/stores/root/quote";
import { scrollMeTo, stat } from "@/utils/Utils";
import { useStatusStore } from "@/stores/root/status";

const title = "Quote";
//anchor!: string;

export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteQuote',
  props: {
  anchor: {
    type: String,
    default: "",
  },
},
  emits: ["quote-changed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const loading: Ref<boolean> = ref(false);
const validationErrors: Ref<any[]> = ref([]);
const emit = __emit;
const inj = inject("$emitter");
const statusStore = useStatusStore();
const refName = ref(null);
const quote = useQuoteStore();

//function formatAmountWithoutCents(amount: number) {
function formatAmountWithoutCent(amount: number) {
  return formatAmountWithoutCents(amount);
}

//function formatAmount(amount: number) {  I dont see usage of this function
// function formatAmounts(amount: number) {
//   return formatAmount(amount);
// }

const validated = computed(() => {
  const rentersValidate =
    quote.rentersInsurance.quoteCoverageDetails.personalPropertyAmount > 0 &&
    quote.rentersInsurance.quoteCoverageDetails.liabilityAmount > 0 &&
    quote.rentersInsurance.quoteCoverageDetails.deductible &&
    quote.rentersInsurance.paymentOption &&
    quote.rentersInsurance.rentersApiOk;

  return rentersValidate;
});

function createValidationMessages(): void {
  validationErrors.value.length = 0;
  if (
    !(quote.rentersInsurance.quoteCoverageDetails.personalPropertyAmount > 0)
  ) {
    const error = {
      name: "personalPropertyAmount",
      value: "Coverage is required.",
    };
    validationErrors.value.push(error);
  }
  if (!(quote.rentersInsurance.quoteCoverageDetails.liabilityAmount > 0)) {
    const error = {
      name: "liabilityAmount",
      value: "Coverage is required.",
    };
    validationErrors.value.push(error);
  }
  if (!(quote.rentersInsurance.paymentOption > 0)) {
    const error = {
      name: "liabilityPaymentPlan",
      value: "Payment option is required.",
    };
    validationErrors.value.push(error);
  }
}

function goToPage(command: string) {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollMeTo("status");
    return;
  }
  quote.hasPersonalInsurance
    ? quote.setQuoteStep(command)
    : quote.setQuoteStep("quote-account");
}

const personalPropertyCoverageItems = computed(() => {
  const personalPrpCovItems = [];
  const min = Number(quote.info.quoteCoverageCue.personalPropertyMin);
  const max = Number(quote.info.quoteCoverageCue.personalPropertyMax);
  const incr = Number(quote.info.quoteCoverageCue.personalPropertyIncrement);
  if (max != 0) {
    for (let i = min; i <= max; i += incr) {
      personalPrpCovItems.push(i);
    }
  }
  return personalPrpCovItems;
});

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  if (!event || !event.target || !event.target.name) {
    return;
  }
  clearValidationMessage(event.target.name);
}

const quoteChange = async (event: any) => {
  (inj as any).emit("quote-changed");
  validatedFieldChanged(event);
};

const rentersQuoteChange = async (event: any) => {
  if (
    quote.rentersInsurance.quoteCoverageDetails.liabilityAmount &&
    quote.rentersInsurance.quoteCoverageDetails.deductible
  ) {
    loading.value = true;
    stat(statusStore).clear();
    const quoteResult = await AssurantData.readAssurantData(quote, true);
    if (quoteResult.error) {
      loading.value = false;
      if (quoteResult.denialNotice !== "") {
        quote.saveDenialNotice(quoteResult.denialNotice);
        quote.saveResponseMessage(quoteResult.message);
        quote.setQuoteStep("quote-denied");
        return;
      }
      if (quoteResult.message == "Quoting Error") {
        alert("Quote unavailable. Please select another option.");
        quote.rentersInsurance.quoteCoverageDetails.deductible = 250;
        quote.rentersInsurance.paymentOption = 0;
        quote.rentersInsurance.dueToday = 0;
        return;
      }
      alert("Something went wrong.");
      quote.rentersInsurance.quoteCoverageDetails.deductible = 250;
      quote.rentersInsurance.paymentOption = 0;
      quote.rentersInsurance.dueToday = 0;
      scrollTop();
      stat(statusStore).error(quoteResult.message);
      //return;
    }
    loading.value = false;
  }
  quoteChange(event);
};

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}

const waterSewerCoverage: ComputedRef<string> = computed(() => {
  if (quote.address.state.short == "NC") {
    return "$5,000";
  }
  if (quote.address.state.short == "MD") {
    return "the property coverage amount";
  }
  return "$2,500";
});

return (_ctx: any,_cache: any) => {
  const _component_red = _resolveComponent("red")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: _unref(loading) }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "title" }, "Renters Insurance", -1)),
        _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "poweredby-hotspot" }, [
          _createElementVNode("span", { class: "poweredby" }, "Provided by Assurant"),
          _createElementVNode("p", { class: "poweredby-content" }, " In all states, unless otherwise noted, Renters Insurance is underwritten by American Bankers Insurance Company of Florida with its home office in Miami, Florida. In Minnesota, the underwriter is American Security Insurance company. In Georgia, Residents Liability is underwritten by Voyager Indemnity Insurance Company. In Utah, coverage is provided under policy form AJ8850PC-0307 or AJ9281CKK-0609. The trade name Assurant is used to associate their products and services, and to connect with the brand of their parent company, Assurant, Inc. ")
        ], -1)),
        _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
        _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
        _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
        _createVNode(StatusComponent),
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createTextVNode(" Property Damage & Personal Liability ", -1)),
          _createVNode(HelpPopup, { msg: "Covers damages to your college dorm, landlord's apartment, or your neighbor's \n            property - like from a resident-caused fire or water damage. In NC, \n            water damage liability protection is optional for Renters Insurance.\n            Will also cover medical and legal expenses if someone gets hurt." })
        ]),
        _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_6, [
                _cache[10] || (_cache[10] = _createElementVNode("strong", { class: "subsubtitle" }, "Coverage", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("red", null, "*", -1)),
                _createVNode(HelpPopup, {
                  msg: "The maximum payout per claim.",
                  "help-class": "help smallhelp"
                })
              ]),
              _createElementVNode("td", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quote).info.quoteCoverageCue
                    .personalLiabilityOptions, (liability) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _withDirectives(_createElementVNode("input", {
                      id: 'liability-coverage-limit-' + liability / 1000,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .liabilityAmount
                    ) = $event)),
                      type: "radio",
                      class: "styledradio",
                      name: "liabilityAmount",
                      value: liability,
                      onChange: rentersQuoteChange
                    }, null, 40, _hoisted_8), [
                      [_vModelRadio, 
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .liabilityAmount
                    ]
                    ]),
                    _createElementVNode("label", {
                      for: 'liability-coverage-limit-' + liability / 1000,
                      style: {"margin-left":"5px !important"}
                    }, _toDisplayString(formatAmountWithoutCent(liability)), 9, _hoisted_9)
                  ], 64))
                }), 256)),
                _createVNode(ValidationError, {
                  name: "liabilityAmount",
                  errors: _unref(validationErrors)
                }, null, 8, ["errors"])
              ])
            ])
          ])
        ]),
        _createElementVNode("table", _hoisted_10, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_11, [
                _cache[12] || (_cache[12] = _createElementVNode("strong", { class: "subsubtitle" }, "Deductible", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("red", null, "*", -1)),
                _createVNode(HelpPopup, {
                  msg: "A deductible is the amount the policyholder must pay before the insurer pays out\n                                        the claim.",
                  "help-class": "help smallhelp"
                })
              ]),
              _createElementVNode("td", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quote).info.quoteCoverageCue
                    .deductibleOptions, (deductible) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: deductible,
                    style: {"display":"inline-block"}
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      id: 'liability-ded-' + deductible,
                      "onUpdate:modelValue": ($event: any) => ((
                      _unref(quote).rentersInsurance.quoteCoverageDetails.deductible
                    ) = $event),
                      type: "radio",
                      class: "styledradio",
                      name: "liability-ded",
                      value: deductible,
                      onChange: rentersQuoteChange
                    }, null, 40, _hoisted_13), [
                      [_vModelRadio, 
                      _unref(quote).rentersInsurance.quoteCoverageDetails.deductible
                    ]
                    ]),
                    _createElementVNode("label", {
                      for: 'liability-ded-' + deductible,
                      style: {"margin-left":"5px !important"}
                    }, _toDisplayString(formatAmountWithoutCent(deductible)), 9, _hoisted_14)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("table", _hoisted_15, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_16, [
                _cache[14] || (_cache[14] = _createElementVNode("strong", { class: "subsubtitle" }, "Payment Options", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("red", null, "*", -1)),
                _createVNode(HelpPopup, {
                  msg: "Choose a payment plan that's best for you: monthly, 4-pay (payments 60 days\n                                        apart), or annual.",
                  "help-class": "help smallhelp"
                })
              ]),
              _createElementVNode("td", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  id: "liab-paymentplan-monthly",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(quote).rentersInsurance.paymentOption) = $event)),
                  type: "radio",
                  class: "styledradio",
                  name: "liabilityPaymentPlan",
                  value: "1",
                  onChange: rentersQuoteChange
                }, null, 544), [
                  [_vModelRadio, _unref(quote).rentersInsurance.paymentOption]
                ]),
                _createElementVNode("label", {
                  name: "liabilityPaymentPlan",
                  for: "liab-paymentplan-monthly",
                  class: _normalizeClass({
                    validationfield: hasErrors('liabilityPaymentPlan'),
                  }),
                  style: {"margin-left":"5px !important"},
                  onClick: validatedFieldChanged
                }, "Monthly ", 2),
                _withDirectives(_createElementVNode("input", {
                  id: "liab-paymentplan-monthly-4-Pay",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(quote).rentersInsurance.paymentOption) = $event)),
                  type: "radio",
                  class: "styledradio",
                  name: "liabilityPaymentPlan",
                  value: "3",
                  onChange: rentersQuoteChange
                }, null, 544), [
                  [_vModelRadio, _unref(quote).rentersInsurance.paymentOption]
                ]),
                _createElementVNode("label", {
                  name: "liabilityPaymentPlan",
                  for: "liab-paymentplan-monthly-4-Pay",
                  class: _normalizeClass({
                    validationfield: hasErrors('liabilityPaymentPlan'),
                  }),
                  style: {"margin-left":"5px !important"},
                  onClick: validatedFieldChanged
                }, "4-Pay ", 2),
                _withDirectives(_createElementVNode("input", {
                  id: "liab-paymentplan-monthly-annual",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(quote).rentersInsurance.paymentOption) = $event)),
                  type: "radio",
                  class: "styledradio",
                  name: "liabilityPaymentPlan",
                  value: "2",
                  onChange: rentersQuoteChange
                }, null, 544), [
                  [_vModelRadio, _unref(quote).rentersInsurance.paymentOption]
                ]),
                _createElementVNode("label", {
                  name: "liabilityPaymentPlan",
                  for: "liab-paymentplan-monthly-annual",
                  class: _normalizeClass({
                    validationfield: hasErrors('liabilityPaymentPlan'),
                  }),
                  style: {"margin-left":"5px !important"},
                  onClick: validatedFieldChanged
                }, "Annual ", 2),
                _createVNode(ValidationError, {
                  name: "liabilityPaymentPlan",
                  errors: _unref(validationErrors)
                }, null, 8, ["errors"])
              ])
            ])
          ])
        ]),
        _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
        _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
        _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
        _cache[37] || (_cache[37] = _createElementVNode("span", {
          for: "addpp",
          class: "subtitle",
          style: {"color":"#414142"}
        }, "Personal Property Coverage ", -1)),
        _createVNode(HelpPopup, { msg: "Covers the stuff you own -- from covered incidents like fire, lightning, and theft." }),
        _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
        _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("table", _hoisted_18, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_19, [
                _cache[17] || (_cache[17] = _createElementVNode("strong", { class: "subsubtitle" }, "Coverage", -1)),
                _cache[18] || (_cache[18] = _createTextVNode()),
                _createVNode(_component_red, null, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("*", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(HelpPopup, {
                  msg: "The maximum payout per claim.",
                  "help-class": "help smallhelp"
                })
              ]),
              _createElementVNode("td", _hoisted_20, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((
                    _unref(quote).rentersInsurance.quoteCoverageDetails
                      .personalPropertyAmount
                  ) = $event)),
                  style: {"width":"60%"},
                  name: "personalPropertyAmount",
                  class: _normalizeClass({
                    validationfield: hasErrors('personalPropertyAmount'),
                  }),
                  onChange: rentersQuoteChange
                }, [
                  _cache[19] || (_cache[19] = _createElementVNode("option", { value: "0" }, "Please Select...", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personalPropertyCoverageItems), (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      value: item
                    }, _toDisplayString(formatAmountWithoutCent(item)), 9, _hoisted_21))
                  }), 128))
                ], 34), [
                  [_vModelSelect, 
                    _unref(quote).rentersInsurance.quoteCoverageDetails
                      .personalPropertyAmount
                  ]
                ]),
                _createVNode(ValidationError, {
                  name: "personalPropertyAmount",
                  errors: _unref(validationErrors)
                }, null, 8, ["errors"])
              ])
            ])
          ])
        ]),
        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "spacer" }, null, -1)),
        _cache[41] || (_cache[41] = _createElementVNode("div", { class: "subtitle" }, "Additional Protection", -1)),
        _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("table", _hoisted_22, [
          _createElementVNode("tbody", null, [
            (_unref(quote).info.quoteCoverageCue.hasReplacementCost == 'Y')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("td", {
                    style: {"width":"75%"},
                    valign: "top"
                  }, [
                    _createElementVNode("span", {
                      id: "replacementcost",
                      onclick: "document.getElementById('replacementcost-content').classList.toggle('show');document.getElementById('replacementcost').classList.toggle('checked');"
                    }, "Replacement Cost"),
                    _createElementVNode("div", {
                      id: "replacementcost-content",
                      class: "additional-content",
                      style: {"display":"none"}
                    }, " Coverage includes reimbursement for the actual cost of replacing belongings. ")
                  ], -1),
                  _createElementVNode("td", { valign: "top" }, [
                    _createElementVNode("div", { class: "additional-included" }, "Included")
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (_unref(quote).info.quoteCoverageCue.hasWaterBackup == 'Y')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                  _createElementVNode("td", _hoisted_25, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", {
                      id: "watersewerbackup",
                      onclick: "document.getElementById('watersewerbackup-content').classList.toggle('show');document.getElementById('watersewerbackup').classList.toggle('checked');"
                    }, "Water Sewer Backup", -1)),
                    _createElementVNode("div", _hoisted_26, " Coverage includes up to " + _toDisplayString(_unref(waterSewerCoverage)) + " in damages if a sewer or drain backs up into your home. A $250 deductible applies. ", 1)
                  ]),
                  _createElementVNode("td", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      id: "3",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((
                    _unref(quote).rentersInsurance.quoteCoverageDetails.waterBackup
                  ) = $event)),
                      name: "",
                      class: "additional-add",
                      "checked:": "",
                      any: "",
                      type: "checkbox",
                      onChange: rentersQuoteChange
                    }, null, 544), [
                      [_vModelCheckbox, 
                    _unref(quote).rentersInsurance.quoteCoverageDetails.waterBackup
                  ]
                    ]),
                    _cache[22] || (_cache[22] = _createElementVNode("label", { for: "3" }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(quote).info.quoteCoverageCue.hasIdFraud == 'Y')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                  _cache[24] || (_cache[24] = _createElementVNode("td", { valign: "top" }, [
                    _createElementVNode("span", {
                      id: "fraudexpense",
                      onclick: "document.getElementById('fraudexpense-content').classList.toggle('show');document.getElementById('fraudexpense').classList.toggle('checked');"
                    }, "Fraud Expense Protection"),
                    _createElementVNode("div", {
                      id: "fraudexpense-content",
                      class: "additional-content",
                      style: {"display":"none"}
                    }, " Identity fraud expense coverage includes up to $15,000 for your expenses as a result of being a victim of identity fraud. A $100 deductible applies. ")
                  ], -1)),
                  _createElementVNode("td", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      id: "4",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((
                    _unref(quote).rentersInsurance.quoteCoverageDetails.identityFraud
                  ) = $event)),
                      name: "",
                      class: "additional-add",
                      type: "checkbox",
                      onChange: rentersQuoteChange
                    }, null, 544), [
                      [_vModelCheckbox, 
                    _unref(quote).rentersInsurance.quoteCoverageDetails.identityFraud
                  ]
                    ]),
                    _cache[23] || (_cache[23] = _createElementVNode("label", { for: "4" }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(quote).info.quoteCoverageCue.hasEarthquake == 'Y')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                  _cache[26] || (_cache[26] = _createElementVNode("td", { valign: "top" }, [
                    _createElementVNode("span", {
                      id: "earthquake",
                      onclick: "document.getElementById('earthquale-content').classList.toggle('show');document.getElementById('earthquake').classList.toggle('checked');"
                    }, "Earthquake"),
                    _createElementVNode("div", {
                      id: "earthquale-content",
                      class: "additional-content",
                      style: {"display":"none"}
                    }, " Coverage includes up to the amount you chose for your belongings and additional living expenses if you need to stay somewhere else. A deductible applies. ")
                  ], -1)),
                  _createElementVNode("td", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      id: "5",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((
                    _unref(quote).rentersInsurance.quoteCoverageDetails.earthquake
                  ) = $event)),
                      name: "",
                      class: "additional-add",
                      type: "checkbox",
                      onChange: rentersQuoteChange
                    }, null, 544), [
                      [_vModelCheckbox, 
                    _unref(quote).rentersInsurance.quoteCoverageDetails.earthquake
                  ]
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("label", { for: "5" }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
        _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
        _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
        _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("button", {
            class: _normalizeClass({ disabled: !_unref(validated) }),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (goToPage('quote-addon')))
          }, " Continue ", 2)
        ]),
        _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
        _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1)),
        _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
        _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
        _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
        _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1))
      ]),
      _createVNode(QuoteCart)
    ])
  ]))
}
}

})